import type { LogisticsTabValue } from '~/routes/_authenticated/logistics/-search-schema'

/**
 * Logique pure de la barre d'onglets Logistique, sans React ni registre de routes : testée par
 * `logistics-tabs-state.test.mjs`. La résolution des onglets est commune (`app-ui/app-tabs-state`).
 */

/** Onglets référentiels : les seuls qui lisent le configurateur industriel (ateliers). */
const REFERENCE_TABS: ReadonlySet<LogisticsTabValue> = new Set(['hubs', 'vehicles', 'hr'])

/**
 * Données lues par l'onglet actif : une requête n'est activée, et son erreur affichée, que pour
 * l'onglet qui la consomme (une requête désactivée garde son erreur en cache).
 */
export const logisticsTabDataNeeds = (activeTab: LogisticsTabValue) => ({
  configurator: REFERENCE_TABS.has(activeTab),
  collaborators: activeTab === 'hr',
  /**
   * Filtres Cuisines centrales et Départements dans la barre d'onglets : la gestion opérationnelle
   * seule, sans Période (ignorée en V1). Ceux du simulateur sont dans son panneau liste (LU-222).
   */
  navBarFilters: activeTab === 'operations',
})
